<template>
  <el-input
    class="width-300"
    v-model="keywords"
    :placeholder="placeholder"
    clearable
    @keyup.enter.native="changeFn"
    @clear="changeFn"
  ></el-input>
</template>

<script>
export default {
  name: 'FilterSearch',
  props: {
    placeholder: {
      type: String,
      default: ''
    },
    value: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      keywords: this.value
    };
  },
  methods: {
    changeFn() {
      this.$emit('change', {
        type: 'search',
        value: this.keywords
      });
    }
  }
};
</script>

<style lang="scss" scoped>
</style>
